export default "__VITE_ASSET__BxSuVMZb__"